import {Component, Input, OnInit} from '@angular/core';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material';
import {FlatTreeControl} from '@angular/cdk/tree';
import {faChevronDown, faChevronRight} from '@fortawesome/free-solid-svg-icons';

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}

interface Node {
  name: string;
  children?: Node[];
}

@Component({
  selector: 'app-tree-table',
  templateUrl: './tree-table.component.html',
  styleUrls: ['./tree-table.component.css']
})
export class TreeTableComponent implements OnInit {

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level, node => node.expandable
  );

  treeFlattener;

  private _data: any[] = undefined;

  private _treeData: any[] = undefined;

  dataSource;

  chevronRight = faChevronRight;
  chevronDown = faChevronDown;

  private _transformer = (node: Node, level: number) => {
    return{
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level
    };
  }

  constructor() { }

  ngOnInit() {
    // this.treeFlattener = new MatTreeFlattener(
    //   this._transformer, node => node.level, node => node.expandable, node => node.children
    // );
  }

  @Input()
  set treeData(value: any[]) {
    this.treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.children
    );
    this._treeData = value;
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener, value);
    this.dataSource.data = value;
  }

  get treeData(): any[] {
    return this._treeData;
  }

  set data(value: any[]) {
    this._data = value;
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataSource.data = value;
  }

  get data(): any[] {
    return this._data;
  }

  getDataSource() {
    return this.dataSource;
  }

  getTreeControl() {
    let l = new FlatTreeControl<any>(node => node.level, node => node.expandable);
    return l;
    // return this._treeData;
  }

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;


}
